import axios from 'axios'

const getData = async (endpoint) => {
    const {data} = await axios({
        method: 'GET',
        url: `${process.env.REACT_APP_API_KEY}${endpoint}`,
        headers: {
          'Api-Key':
            '2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130',
          Authorization: `Bearer ${localStorage.token}`
        }
      })
    return data
} 
const localValidation = (obj) => {
  let errorCount = 0
  for(const key in obj){
    switch(key){
      case("subProject"):
        errorCount = 0
        break;
      case("projectClasses"):
        errorCount = 0
        break;
      case("unitPrice"):
        if(!obj[key]) errorCount = 1
        break;
      default:
        if(!obj[key]) errorCount = 1
    }
    if(errorCount === 1) {
      return key
    }
  }
  return null
}

const allowNumberInputs = (value) => {
  let newValue = ""
  for(let no = 0; no < value.length; no++){
    if(value[no] <= 9){
      newValue += value[no]
    }
  }
  return newValue
}

export { getData, localValidation, allowNumberInputs }